<template>
  <div class="small mb-3">
    <template v-if="hasNotifications">
      <div class="font-italic">Notifications Sent:</div>
      <div v-if="emailNames.length > 0" class="ml-3">
        <span class="fas fa-envelope mr-1"></span> {{ emailNames.join(', ') }}
      </div>
      <div v-if="smsNames.length > 0" class="ml-3">
        <span class="fas fa-sms mr-1"></span> {{ smsNames.join(', ') }}
      </div>
      <div class="ml-3" v-for="message in inbasketMessages" :idx="message.id">
        <span class="fas fa-inbox mr-1"></span>
        <span v-if="message.destination_type === 'Pool'">Inbasket Pool {{ message.pool_id }}</span>
        <span v-else>Inbasket message to {{ message.epic_usernames.join(', ') }}</span>
        <span class="fa fa-info-circle" :id="`popover-${message.id}`"></span>
        <b-popover :target="`popover-${message.id}`" triggers="hover" placement="top">
          Status: {{ message.status }}<br>
          Epic Message ID: {{ message.epic_message_id }}<br>
          Message Type: {{ message.message_type }}
        </b-popover>
      </div>
    </template>
  </div>
</template>

<script>
import { BPopover } from 'bootstrap-vue';

export default {
  name: "Notifications",
  components: {
    BPopover,
  },
  props: {
    notifications: {
      type: Array,
      default: function() {
        return [];
      }
    },
    inbasketMessages: {
      type: Array,
      default: function() {
        return [];
      }
    },
  },
  computed: {
    hasNotifications() {
      return this.emailNames.length > 0 || this.smsNames.length > 0 || this.inbasketMessages.length > 0;
    },
    emailNames() {
      return this.notifications.filter(notification => notification.send_email).map(notification => notification.staff.name)
    },
    smsNames() {
      return this.notifications.filter(notification => notification.send_text).map(notification => notification.staff.name)
    },
  }
}
</script>

<style scoped>

</style>